module.exports = __webpack_public_path__ + "img/6X4.569fc56f.png";